import styled from 'styled-components';

import { COLORS } from '../styles';

export const List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  width: 100%;
`;

export const Card = styled.label<{ isSelected: boolean; isDisabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 8px;
  border: ${({ isSelected }) =>
    isSelected ? `2px solid ${COLORS.primary}` : `1px solid ${COLORS.border}`};
  background: ${({ isSelected }) => (isSelected ? COLORS.primarySoft : '#ffffff')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${({ isDisabled }) => (isDisabled ? COLORS.border : COLORS.primary)};
  }

  input {
    margin-top: 4px;
    accent-color: ${COLORS.primary};
  }
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${COLORS.text};
`;

export const Details = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: ${COLORS.muted};

  b {
    color: ${COLORS.text};
  }
`;

export const Unavailable = styled.span`
  margin-left: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #db2828;
`;
